import React, { useEffect, useState, useCallback } from "react";
import "./css/Login.scss";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, Form, Input, Row, Col, message, Image } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import Captcha from "react-captcha-code";
import BoxServe from "../../ajax/api/index";
import { baseURL } from "../../ajax/globalConfig";

export default function Login() {
  const captchaImgUrl = baseURL + "/captcha?rand = " + new Date().getTime();
  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();

  const [captchaImg, setCaptchaImg] = useState(captchaImgUrl);
  let navigete = useNavigate();
  // // 判断是否已登录，登录返回主页

  const onFinish = async (values) => {
    try {
      const { code, data, msg } = await BoxServe.getLogin({
        ...values,
      });
      if (String(code) === "0") {
        console.log(data);
        localStorage.setItem("token", data?.token);
        localStorage.setItem("role", data?.role);
        message.success({
          content: "登录成功",
          duration: 3,
          onClose: () => {
            navigete("/device/deviceHome");
          },
        });
      } else {
        messageApi.open({
          type: "warning",
          content: msg,
        });
      }
    } catch (error) {
      message.error(error.message || error.msg);
      console.log(error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // 获取验证码
  const handleGetCaptcha = () => {
    setCaptchaImg(baseURL + "/captcha?rand = " + new Date().getTime());
  };

  useEffect(() => {
    handleGetCaptcha();
  }, []);

  return (
    <>
      {contextHolder}
      <div className="form-wrap">
        <div className="form-mian">
          <div className="left">
            <p className="text"></p>
          </div>
          <div className="right">
            <div className="right-title">
              <p className="text">华维网络设备管理系统</p>
            </div>
            <Form
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ maxWidth: 600 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="用户名"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "请输入登录用户名",
                  },
                ]}
              >
                <Input size="large" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="请输入登录用户名" />
              </Form.Item>

              <Form.Item
                label="登录密码"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "请输入登录密码",
                  },
                ]}
              >
                <Input.Password size="large" prefix={<LockOutlined className="site-form-item-icon" />} placeholder="请输入登录密码" />
              </Form.Item>

              <Form.Item label="验证码" extra="">
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item
                      name="captcha"
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "请输入验证码",
                        },
                      ]}
                    >
                      <Input size="large" placeholder="请输入验证码" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Image id="captcha-img" className="formImg" preview={false} src={captchaImg} onClick={handleGetCaptcha} />
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item
                name="remember"
                valuePropName="checked"
                wrapperCol={{
                  offset: 4,
                  span: 20,
                }}
              >
                <Checkbox>记住我</Checkbox>
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  offset: 4,
                  span: 20,
                }}
              >
                <Button
                  // type="primary"
                  htmlType="submit"
                  size="large"
                  className="btn-wrap"
                  style={{ width: "100%" }}
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
            <p className="copyright">©2023 Created by Huawei Network</p>
          </div>
        </div>
      </div>
    </>
  );
}
